import React from 'react';

/**
 * Adds speculation rules to the page to improve performance.
 *
 * Add `data-prefetch` attribute to elements you want to prefetch.
 * Add `data-prefetch="prerender"` to elements you want to prerender.
 * Add `data-prefetch="false"` to elements you don't want to prefetch (also not on hover).
 *
 * @see https://developer.chrome.com/docs/web-platform/prerender-pages
 * @see https://csswizardry.com/2024/12/a-layered-approach-to-speculation-rules/
 */
export const SpeculationRules = () => {
	return (
		<script type="speculationrules">
			{JSON.stringify({
				prefetch: [
					{
						where: {
							selector_matches: "[data-prefetch='']",
						},
						eagerness: 'immediate',
					},
					{
						where: {
							and: [{ href_matches: '/*' }, { not: { selector_matches: '[data-prefetch=false]' } }],
						},
						eagerness: 'moderate',
					},
				],
				prerender: [
					{
						where: {
							selector_matches: '[data-prefetch=prerender]',
						},
						eagerness: 'immediate',
					},
					{
						where: {
							selector_matches: "[data-prefetch='']",
						},
						eagerness: 'moderate',
					},
				],
			})}
		</script>
	);
};
